import React, { useState } from 'react'
import { useT } from '../helpers/useT'
import { ListResponse, constructAthenaUrl, useFetch } from '../api/useFetch'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderCell,
  TableHeaderRow,
  TableRow
} from '../components/List/Table'
import { Headline } from '../components/Headline'
import { EmptyListPlaceholder } from '../components/List/EmptyList'
import { ListFilters, Pagination } from '../components/List/List'
import { Status } from '../components/Status'
import DetailsLink from '../components/DetailsLink'
import { Vehicle } from './vehicle'
import { AddRecordLink } from '../list/AddItemToListCTA'
// @ts-ignore
import { vehicleAdd } from '../routes'
// @ts-ignore
import { CanDos } from 'types/Role'
import { ApiResponseAware } from '../api/ApiResponseAware'

export function VehicleList ({ canDo }: { canDo: CanDos }) {
  const t = useT()
  const [currentPage, setCurrentPage] = useState(1)
  const getVehiclesCall = useFetch<ListResponse<Vehicle>>(
    constructAthenaUrl('/hades/vehicles', {
      'page[number]': `${currentPage}`,
      'page[size]': '30'
    })
  )

  return (
    <ApiResponseAware
      apiCall={getVehiclesCall}
      render={({ data: vehicles, meta }: ListResponse<Vehicle>) => (
        <>
          <Headline title={t('vehicles.title')}>
            {canDo.add && (
              <AddRecordLink link={vehicleAdd()}>
                {t('vehicles.add-item-link')}
              </AddRecordLink>
            )}
          </Headline>
          <ListFilters
            recordCount={t('vehicles.record-count', {
              number: meta.record_count
            })}
          />
          <EmptyListPlaceholder
            data={vehicles}
            title={t('vehicles.empty-list')}
          >
            <Table>
              <TableHead>
                <TableHeaderRow>
                  <TableHeaderCell width={120}>
                    {t('shared.plate')}
                  </TableHeaderCell>
                  <TableHeaderCell>{t('shared.model')}</TableHeaderCell>
                  <TableHeaderCell width={100}>
                    {t('shared.color')}
                  </TableHeaderCell>
                  <TableHeaderCell width={100}>
                    {t('shared.production-year')}
                  </TableHeaderCell>
                  <TableHeaderCell width={120}>
                    {t('shared.service-class')}
                  </TableHeaderCell>
                  <TableHeaderCell width={90}>
                    {t('shared.status')}
                  </TableHeaderCell>
                  <TableHeaderCell width={60} />
                </TableHeaderRow>
              </TableHead>
              <TableBody>
                {vehicles.map(vehicle => (
                  <TableRow key={vehicle.id}>
                    <TableCell>{vehicle.attributes.plate}</TableCell>
                    <TableCell>{vehicle.attributes.model}</TableCell>
                    <TableCell>{vehicle.attributes.color || '-'}</TableCell>
                    <TableCell>{vehicle.attributes.year}</TableCell>
                    <TableCell>
                      {t(`shared.service.${vehicle.attributes.vehicle_class}`)}
                    </TableCell>
                    <TableCell>
                      <Status status={vehicle.attributes.state} />
                    </TableCell>
                    <TableCell>
                      <DetailsLink section='vehicles' qs={{ id: vehicle.id }} />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Pagination
              currentPage={currentPage}
              pageCount={meta.page_count}
              onPageClick={setCurrentPage}
            />
          </EmptyListPlaceholder>
        </>
      )}
    />
  )
}
